import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../api';
import Layout from '../components/Layout';

const PRESET_SMTP = [
  { label: 'Aruba PEC', host: 'smtps.pec.aruba.it', port: 465, secure: true },
  { label: 'Legalmail (InfoCert)', host: 'sendm.cert.legalmail.it', port: 465, secure: true },
  { label: 'Namirial PEC', host: 'smtp.sicurezzapostale.it', port: 465, secure: true },
  { label: 'Register PEC', host: 'smtp.pec.register.it', port: 465, secure: true },
  { label: 'Gmail', host: 'smtp.gmail.com', port: 587, secure: false },
  { label: 'Outlook / Office 365', host: 'smtp.office365.com', port: 587, secure: false },
  { label: 'Aruba Mail', host: 'smtps.aruba.it', port: 465, secure: true },
  { label: 'Personalizzato', host: '', port: 465, secure: true },
];

export default function ConfigEmail() {
  const { utente } = useAuth();
  const [form, setForm] = useState({
    email_mittente: '', smtp_host: '', smtp_port: 465, smtp_user: '', smtp_password: '', smtp_secure: true,
  });
  const [configStudio, setConfigStudio] = useState({ email_cc: '', email_ministero: 'intermittenti@pec.lavoro.gov.it', alert_giorni_inattivita: 30 });
  const [configurato, setConfigurato] = useState(false);
  const [messaggio, setMessaggio] = useState('');
  const [errore, setErrore] = useState('');
  const [testInCorso, setTestInCorso] = useState(false);
  const [salvataggio, setSalvataggio] = useState(false);
  const [aziende, setAziende] = useState([]);
  const [aziendaSel, setAziendaSel] = useState('');

  useEffect(() => {
    if (utente.ruolo === 'studio') {
      api.get('/aziende').then(r => setAziende(r.data)).catch(() => {});
      api.get('/email/studio').then(r => { if (r.data) setConfigStudio(r.data); }).catch(() => {});
    }
  }, [utente.ruolo]);

  useEffect(() => {
    const aziendaId = utente.ruolo === 'studio' ? aziendaSel : undefined;
    if (utente.ruolo === 'studio' && !aziendaSel) return;

    api.get('/email/configurazione', { params: { azienda_id: aziendaId } }).then(r => {
      if (r.data) {
        setForm({ ...r.data, smtp_password: '' });
        setConfigurato(true);
      } else {
        setForm({ email_mittente: '', smtp_host: '', smtp_port: 465, smtp_user: '', smtp_password: '', smtp_secure: true });
        setConfigurato(false);
      }
    }).catch(() => {});
  }, [utente.ruolo, aziendaSel]);

  const applicaPreset = (preset) => {
    setForm(prev => ({ ...prev, smtp_host: preset.host, smtp_port: preset.port, smtp_secure: preset.secure }));
  };

  const salva = async (e) => {
    e.preventDefault();
    setErrore(''); setMessaggio(''); setSalvataggio(true);
    try {
      const payload = { ...form };
      if (utente.ruolo === 'studio') payload.azienda_id = aziendaSel;
      await api.post('/email/configurazione', payload);
      setMessaggio('Configurazione salvata con successo');
      setConfigurato(true);
    } catch (err) {
      setErrore(err.response?.data?.errore || 'Errore nel salvataggio');
    } finally {
      setSalvataggio(false);
    }
  };

  const testEmail = async () => {
    setErrore(''); setMessaggio(''); setTestInCorso(true);
    try {
      const payload = utente.ruolo === 'studio' ? { azienda_id: aziendaSel } : {};
      const res = await api.post('/email/test', payload);
      setMessaggio(res.data.messaggio);
    } catch (err) {
      setErrore(err.response?.data?.errore || 'Errore nel test');
    } finally {
      setTestInCorso(false);
    }
  };

  const salvaStudio = async (e) => {
    e.preventDefault();
    setErrore(''); setMessaggio('');
    try {
      await api.put('/email/studio', configStudio);
      setMessaggio('Configurazione studio aggiornata');
    } catch (err) {
      setErrore(err.response?.data?.errore || 'Errore nel salvataggio');
    }
  };

  const aggiorna = (campo, valore) => setForm(prev => ({ ...prev, [campo]: valore }));

  return (
    <Layout>
      <h2 style={{ marginTop: 0 }}>Configurazione Email / PEC</h2>

      {messaggio && <div style={styles.successo}>{messaggio}</div>}
      {errore && <div style={styles.errore}>{errore}</div>}

      {utente.ruolo === 'studio' && (
        <div style={styles.sezione}>
          <h3>Impostazioni Studio</h3>
          <form onSubmit={salvaStudio}>
            <div style={styles.row}>
              <div style={styles.campo}>
                <label>Email/PEC Studio (sempre in CC)</label>
                <input type="email" value={configStudio.email_cc} onChange={e => setConfigStudio(p => ({ ...p, email_cc: e.target.value }))} required style={styles.input} />
              </div>
              <div style={styles.campo}>
                <label>Email/PEC Ministero del Lavoro</label>
                <input type="email" value={configStudio.email_ministero} onChange={e => setConfigStudio(p => ({ ...p, email_ministero: e.target.value }))} required style={styles.input} />
              </div>
              <div style={styles.campo}>
                <label>Alert inattività (giorni)</label>
                <input type="number" value={configStudio.alert_giorni_inattivita} onChange={e => setConfigStudio(p => ({ ...p, alert_giorni_inattivita: parseInt(e.target.value) }))} min={1} style={styles.input} />
              </div>
            </div>
            <button type="submit" style={styles.btn}>Salva Impostazioni Studio</button>
          </form>
        </div>
      )}

      <div style={styles.sezione}>
        <h3>Configurazione SMTP {utente.ruolo === 'studio' ? 'Cliente' : ''}</h3>

        {utente.ruolo === 'studio' && (
          <div style={styles.campo}>
            <label>Seleziona Azienda</label>
            <select value={aziendaSel} onChange={e => setAziendaSel(e.target.value)} style={styles.input}>
              <option value="">-- Seleziona --</option>
              {aziende.map(a => <option key={a.id} value={a.id}>{a.ragione_sociale}</option>)}
            </select>
          </div>
        )}

        {(utente.ruolo === 'cliente' || aziendaSel) && (
          <form onSubmit={salva}>
            <div style={styles.campo}>
              <label>Provider (preset)</label>
              <div style={styles.presetGrid}>
                {PRESET_SMTP.map(p => (
                  <button
                    type="button" key={p.label}
                    onClick={() => applicaPreset(p)}
                    style={form.smtp_host === p.host ? { ...styles.presetBtn, ...styles.presetBtnActive } : styles.presetBtn}
                  >
                    {p.label}
                  </button>
                ))}
              </div>
            </div>

            <div style={styles.campo}>
              <label>Email mittente (PEC o email)</label>
              <input type="email" value={form.email_mittente} onChange={e => aggiorna('email_mittente', e.target.value)} required style={styles.input} placeholder="azienda@pec.it" />
            </div>

            <div style={styles.row}>
              <div style={styles.campo}>
                <label>Server SMTP</label>
                <input type="text" value={form.smtp_host} onChange={e => aggiorna('smtp_host', e.target.value)} required style={styles.input} placeholder="smtps.pec.aruba.it" />
              </div>
              <div style={{ ...styles.campo, maxWidth: '120px' }}>
                <label>Porta</label>
                <input type="number" value={form.smtp_port} onChange={e => aggiorna('smtp_port', parseInt(e.target.value))} required style={styles.input} />
              </div>
              <div style={{ ...styles.campo, maxWidth: '80px', display: 'flex', flexDirection: 'column' }}>
                <label>SSL/TLS</label>
                <input type="checkbox" checked={form.smtp_secure} onChange={e => aggiorna('smtp_secure', e.target.checked)} style={{ marginTop: '0.8rem', width: '20px', height: '20px' }} />
              </div>
            </div>

            <div style={styles.row}>
              <div style={styles.campo}>
                <label>Username SMTP</label>
                <input type="text" value={form.smtp_user} onChange={e => aggiorna('smtp_user', e.target.value)} required style={styles.input} placeholder="username@pec.it" />
              </div>
              <div style={styles.campo}>
                <label>Password SMTP {configurato && '(lascia vuoto per non modificare)'}</label>
                <input type="password" value={form.smtp_password} onChange={e => aggiorna('smtp_password', e.target.value)} required={!configurato} style={styles.input} />
              </div>
            </div>

            <div style={styles.actionRow}>
              <button type="submit" disabled={salvataggio} style={styles.btn}>
                {salvataggio ? 'Salvataggio...' : 'Salva Configurazione'}
              </button>
              {configurato && (
                <button type="button" onClick={testEmail} disabled={testInCorso} style={styles.btnSecondary}>
                  {testInCorso ? 'Test in corso...' : 'Invia Email di Test'}
                </button>
              )}
            </div>
          </form>
        )}
      </div>
    </Layout>
  );
}

const styles = {
  sezione: { background: 'white', padding: '1.5rem', borderRadius: '10px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', marginBottom: '1.5rem' },
  campo: { marginBottom: '1rem', flex: 1 },
  input: { width: '100%', padding: '0.6rem', border: '1px solid #ddd', borderRadius: '6px', fontSize: '0.95rem', boxSizing: 'border-box', marginTop: '0.3rem' },
  row: { display: 'flex', gap: '1rem', flexWrap: 'wrap' },
  actionRow: { display: 'flex', gap: '0.5rem', marginTop: '1rem' },
  btn: { background: '#232323', color: 'white', border: 'none', padding: '0.6rem 1.2rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem' },
  btnSecondary: { background: 'white', color: '#333', border: '1px solid #ddd', padding: '0.6rem 1.2rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem' },
  presetGrid: { display: 'flex', flexWrap: 'wrap', gap: '0.4rem', marginTop: '0.3rem' },
  presetBtn: { background: '#f0f2f5', border: '1px solid #ddd', padding: '0.4rem 0.8rem', borderRadius: '6px', cursor: 'pointer', fontSize: '0.8rem' },
  presetBtnActive: { background: '#232323', color: 'white', borderColor: '#232323' },
  successo: { background: '#e8f5e9', color: '#2e7d32', padding: '0.7rem', borderRadius: '6px', marginBottom: '1rem' },
  errore: { background: '#fee', color: '#c00', padding: '0.7rem', borderRadius: '6px', marginBottom: '1rem' },
};
